import { apiSlice } from "../apiSlice";
const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PROD;
interface CreateAnonymousCustomerRequest {
    displayName: String;
    email: string;
    phoneNumber: string
}
interface CreateAnonymousCustomerResponse {
    id: any;
    customer: string
}

export const CustomerService = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        createAnonymousCustomer: builder.mutation<CreateAnonymousCustomerResponse, CreateAnonymousCustomerRequest>({
            query: (data) => ({
                url: `https://customerhttps-createanonymouscustomer${API_BASE_DOMAIN}`,
                method: "POST",
                body: data,
                headers: {
                    "Content-Type": "application/json"
                }
            })
        })
    })
});

export const { useCreateAnonymousCustomerMutation } = CustomerService;